<template>
  <b-modal title="Kayıt Dönüştür" v-model="show" ref="modal" @hide="hideModal()">
    <b-form-group label="Ödeme Tarihi">
      <b-form-input v-model="date" type="date" />
    </b-form-group>
    <template v-slot:modal-footer>
      <b-button @click="hideModal()">Vazgeç</b-button>
      <b-button @click="changeType" variant="primary" :disabled="$v.$invalid || loadingButton">
        <i v-if="loadingButton" class="fa fa-spinner"></i> Gidere Dönüştür</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ChangeAccountingType',
  props: ['show', 'id', 'to'],
  data() {
    return {
      loadingButton: false,
      date: moment().format('YYYY-MM-DD'),
    }
  },
  methods: {
    ...mapActions(['changeAccountingType']),
    changeType() {
      this.loadingButton = true;
      this.changeAccountingType({
        id: this.id,
        date: this.date,
        type: this.to,
      }).then(res => {
        this.loadingButton = false;
        this.success(res.data.message);
        this.$refs.modal.hide();
        this.$emit('refresh-table')
      }).catch(error => {
        this.loadingButton = false;
        this.error(error.response.data.message);
      });
    },
    hideModal() {
      this.$emit('hide');
    },
  },
  validations: {
    date: { required }
  }
}
</script>
